/**
 * @version GENERATOR_VERSION::20200504
 * @DateTime 2020-12-01T19:13:36.229
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
	auth: true
};

const pre = 'storagemanage-ConDeputeContractBackSettlement-'

export default {
	path: '/storagemanage/condeputecontractbacksettlement',
	name: 'storagemanage-ConDeputeContractBackSettlement',
	redirect: {
		name: '${pre}-index'
	},

	meta: {
		...meta,
	},

	component: BasicLayout,
	children: [{
			path: 'index',
			name: '${pre}ConDeputeContractBackSettlement-index',

			meta: {
				...meta,
				title: '解约业务结算帐单'
			},

			component: () => import('@/pages/storagemanage/condeputecontractbacksettlement/index'),
		},
		{
			path: 'detail-edit/:id',
			name: '${pre}ConDeputeContractBackSettlement-detail-edit',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '解约业务结算帐单编辑'
			},

			component: () => import('@/pages/storagemanage/condeputecontractbacksettlement/detail-edit'),
		},
		{
			path: 'detail-edit',
			name: '${pre}ConDeputeContractBackSettlementdetail-create',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '解约业务结算帐单新增'
			},

			component: () => import('@/pages/storagemanage/condeputecontractbacksettlement/detail-edit'),
		},
		{
			path: 'detail-view/:id',
			name: '${pre}ConDeputeContractBackSettlementView',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '解约业务结算帐单详情查看'
			},

			component: () => import('@/pages/storagemanage/condeputecontractbacksettlement/detail-view'),
		},
	]
};
